import React, { useState, useMemo, useEffect } from 'react'
import Card from 'react-bootstrap/Card';
import ReactDataTableBootstrap from '../../Components/ReactDataTableBootstrap/ReactDataTableBootstrap';
import Controllers from '../../Api/Controllers';
import Helpers from '../../Components/Helpers/Helpers';
import { toast } from 'react-toastify'
import { FormCustom, Select } from '../../Components/Form/Form';
import Button from 'react-bootstrap/Button'
import Loading from '../../Components/Layout/Styled/Loading'
import { useSelector } from 'react-redux';
import ReactPlaceholder from 'react-placeholder/lib';

const ReporteEcommercePublico = () => {
    const [isProcessing, setIsProccesing] = useState(false)
    const [rows, setRows] = useState([])
    const [reporte, setReport] = useState({})
    const [period, setPeriod] = useState([])
    const [ready, setReady] = useState(false)
    const [periodSelected, setPeriodSelected] = useState('')
    const [isAdmin, setIsAdmin] = useState(false);
    const session = useSelector(store => store.session)

    useEffect(() => {
        if (session.type === 2) {
            setIsAdmin(true)
        }
    }, [session])

    const dtRows = useMemo(() => <ReactDataTableBootstrap
        head={[
            [
                { name: 'id_document', text: 'ID', align: 'center' },
                { name: 'date_doc', text: 'Fecha', align: 'center' },
                {
                    name: 'name_branch_office', text: 'Sucursal', render: r => {
                        return <div>{r.key_branch_office} - {r.name_branch_office}</div>
                    }
                },
                { name: 'id_customers', text: 'Id Cliente', align: 'center' },
                { name: 'full_name_customers', text: 'Cliente' },
                {
                    name: 'source_doc', text: 'Tipo Venta', align: 'center', render: r => {
                        let text = 'VENTA'
                        let color = 'success'

                        switch (r.source_doc) {
                            case 'ECOMMERCE_PENDIENTE':
                                text = 'ECOMMERCE_PENDIENTE'
                                color = 'warning'
                                break;
                            case 'ECOMMERCE_PAGADO':
                                text = 'ECOMMERCE_PAGADO'
                                color = 'info'
                                break;

                            default:
                                break;
                        }

                        return <div className={'badge badge-' + (color)}>
                            {text}
                        </div>
                    }
                },
                {
                    name: 'anulado', text: 'Estado', align: 'center', render: r => {
                        return <div className={'text-center font-weight-bold text-' + r.anulado_color}>
                            {r.anulado_text}
                        </div>
                    }
                },
                {
                    name: 'full_name_cart', text: 'Cliente Final', render: r => {
                        return <div>
                            <div>Nombres: {r.full_name_cart}</div>
                            <div>Telefono: {r.phone_cart}</div>
                            <div>Email: {r.email_cart}</div>
                        </div>
                    }
                },
                { name: 'subtotal_earnings', text: 'Comisión' },
                { name: 'type_fee', text: 'Régimen', align: 'center' },
                { name: 'isr', text: 'ISR', align: 'center', render: r => r.isr ? '$ ' + r.isr : '' },
                { name: 'iva', text: 'IVA', align: 'center', render: r => r.iva ? '$ ' + r.iva : '' },
                { name: 'ret_iva', text: 'RET IVA', align: 'center', render: r => r.ret_iva ? '$ ' + r.ret_iva : '' },
                { name: 'resico', text: 'RESICO', align: 'center', render: r => r.resico ? '$ ' + r.resico : '' },
                { name: 'total', text: 'Total', align: 'center', render: r => r.total ? '$ ' + r.total : '' },
            ],
        ]}
        rows={rows ? rows : []}
        pageLength={100}
        isProcessing={isProcessing}
    />, [rows, isProcessing])

    /* const [data, setData] = useState({
        p_id_customers: ''
    }) */
    const [showLoading, setShowLoading] = useState(false)

    useEffect(() => {
        Controllers.period.get_period().then(res => {
            setPeriod(res.data)
            setReady(true);
        })
    }, [])

    return <>
        <ReactPlaceholder rows={10} showLoadingAnimation ready={ready}>
            <Card>
                <Card.Header className="justify-content-between">
                    <span>Reporte Ecommerce Público</span>
                </Card.Header>
                <Card.Body>
                    <FormCustom viewSubmit={false} onSubmit={_ => {
                        if (isNaN(parseInt(periodSelected))) {
                            Helpers.toast.construct({
                                response: 'warning',
                                message: 'Debe seleccionar un periodo',
                                toast
                            })
                            return
                        }
                        setRows([])
                        setIsProccesing(true)
                        setShowLoading(true)
                        setReport({})

                        Controllers.ecommerce_publico.reporte_ecommerce_publico({
                            p_is_admin: isAdmin ? 1 : 0,
                            p_id_period: periodSelected
                        }).then(res => {
                            if (res.response !== 'success') {
                                Helpers.toast.construct({ ...res, toast })
                                return
                            }
                            setRows(res.data.rows)
                            setReport({
                                excel: res.data.excel.file,
                                filename: res.data.excel.filename,
                            })
                        }).catch(req => Helpers.promise.catch({ req, toast }))
                            .finally(() => {
                                setIsProccesing(false)
                                setShowLoading(false)
                            })
                    }}>
                        {/* isAdmin && <>
                            <Input
                                classNameParent="col-12 mb-2"
                                type="number"
                                pattern="[0-9]{1,9}"
                                icon="fa fa-user"
                                placeholder="Id Cliente"
                                text="Id Cliente"
                                required
                                onChange={e => {
                                    setData({ ...data, p_id_customers: e.currentTarget.value, p_full_name_customers: '' })
                                    setRows([])
                                    setReport({})
                                }}
                                append={[
                                    <Button type="submit">
                                        <i className="fa fa-search"></i>
                                    </Button>
                                ]}
                                value={data.p_id_customers}
                            />
                        </> */}
                        <Select
                            icon="fa fa-building"
                            text="Periódo"
                            classNameParent="col-12 mb-2"
                            options={period.map(p => {
                                return {
                                    label: p.name_period,
                                    value: p.id_period
                                }
                            })}
                            onChange={e => setPeriodSelected(e.value)}
                            append={/* isAdmin ? [] :  */[
                                <Button type="submit">
                                    <i className="fa fa-search"></i>
                                </Button>
                            ]}
                        />
                    </FormCustom>
                    {reporte?.filename ? <div className='mb-4'>
                        <a href={reporte?.excel} download={reporte?.filename} className="mr-2">
                            <Button size="sm" variant="success">
                                <i className="fa fa-file-excel mr-2"></i>Descargar Reporte Excel
                            </Button>
                        </a>
                    </div> : ''}
                    {dtRows}
                </Card.Body>
            </Card>
            <Loading show={showLoading}>
                <Loading.Img src={Helpers.config.resourcesUrl({ url: '/images/dashboard/preloading.svg' })} alt="Preloading" />
            </Loading>
        </ReactPlaceholder>
    </>
}

export default ReporteEcommercePublico